"use client";

import { c as _c } from "react/compiler-runtime";
import { FiMinus, FiPlus } from "react-icons/fi";
import { RiFullscreenExitLine } from "react-icons/ri";
import { Button } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  className?: string;
}
export function ZoomControls(t0) {
  const $ = _c(19);
  const {
    zoom,
    onZoomIn,
    onZoomOut,
    onResetZoom,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex items-center gap-1 rounded-lg border bg-background/70 backdrop-blur-sm shadow-md px-1 py-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = zoom <= 0.25;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FiMinus size={14} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onZoomOut || $[4] !== t2) {
    t4 = <Button variant="ghost" size="sm" onClick={onZoomOut} disabled={t2} className="h-7 w-7 p-0" aria-label="Zoom out" icon={t3} />;
    $[3] = onZoomOut;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = zoom === 1;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <RiFullscreenExitLine size={14} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onResetZoom || $[8] !== t5) {
    t7 = <Button variant="ghost" size="sm" onClick={onResetZoom} disabled={t5} className="h-7 w-7 p-0" aria-label="Reset zoom" icon={t6} />;
    $[7] = onResetZoom;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = zoom >= 2;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FiPlus size={14} />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onZoomIn || $[12] !== t8) {
    t10 = <Button variant="ghost" size="sm" onClick={onZoomIn} disabled={t8} className="h-7 w-7 p-0" aria-label="Zoom in" icon={t9} />;
    $[11] = onZoomIn;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t1 || $[15] !== t10 || $[16] !== t4 || $[17] !== t7) {
    t11 = <div className={t1}>{t4}{t7}{t10}</div>;
    $[14] = t1;
    $[15] = t10;
    $[16] = t4;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}